module.exports = __webpack_public_path__ + "img/no-data.b968283c.png";